import React from 'react';
import Hero from '../components/Hero';
import CareerExplorerCTA from '../components/CareerExplorerCTA';
import ProblemSection from '../components/ProblemSection';
import CapabilitiesSection from '../components/CapabilitiesSection';
import BuiltForSection from '../components/BuiltForSection';
import StreamsSection from '../components/StreamsSection';
import CollegeApplicationCTA from '../components/CollegeApplicationCTA';
import InstitutionSection from '../components/InstitutionSection';
import TrustSection from '../components/TrustSection';
import CTASection from '../components/CTASection';

const HomePage = () => {
  return (
    <>
      <Hero />
      <CareerExplorerCTA />
      <ProblemSection />
      <CapabilitiesSection />
      <BuiltForSection />
      <StreamsSection />
      <CollegeApplicationCTA />
      <InstitutionSection />
      <TrustSection />
      <CTASection />
    </>
  );
};

export default HomePage;
